/**
 * Menuraq Utility Functions — barrel re-export module.
 * Individual functions live in focused modules; this file re-exports
 * them for backward compatibility.
 */


// Re-export all focused modules
export { useResponsiveScale, useResponsiveScaleCanvas } from "./templateResponsive";
export { buildMenuData } from "./menuDataBuilder";
export {
  resolvePath, resolveBindings, resolveAllBindings, isBindingMap,
  hasRenderableValue, pickRenderableText, renderTextOrChildren,
  resolveDirectValue, resolveRenderableValue,
  bindingHelpers, resolveBinding, resolveBindingExpression,
  resolveLabelBinding, resolveTemplateTokenString,
  resolveClassName, buildAvailabilityWindow,
  evaluateSafeExpression,
} from "./templateBindings";
export {
  normalizeFontFamily,
  resolveTemplateThemeMode,
  resolveTemplateVariables,
  resolveStyleBindings,
  resolveClassNameBindings,
  computeStyle,
  applyTextUtils,
} from "./templateStyles";
export {
  normalizeLookupKey,
  isFeaturedItem,
  resolveRepeaterCollection,
  inferRepeaterContextKey,
  extendRepeaterContext,
  resolveActivePromotion,
  paginate,
  splitColumns,
  findNodeById,
  findNodesByProp,
  getRandomImage,
  getItemsPerPage,
  generateNodeId,
  injectBindings,
  findAllRepeaters,
  isUniqueNodeId,
  buildNodeIdMap,
  formatPrice,
} from "./templateNodes";
export type { RepeaterContextKey } from "./templateNodes";

export {
  DEFAULT_TIMEZONE,
  getZonedDateParts,
  parseTimeToMinutes,
  isItemScheduleActive,
  pickCategoryCollectionId,
  readStr,
  readNum,
  readBool,
  slugifyMenuCollection,
  buildSectionArtifacts,
} from "./templateMenuHelpers";
